
export const imagePath = "/nfts";

export const imagesPerPage = 6 * 8;
